import { useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '../contexts/AppContext';
import { Header as CoreHeader, Menu, SiderMenuLayout, ThemeSettings } from '@meteor/frontend-core';
import { defaultTheme } from '../consts/common/default-configuration';
import { registerList } from '../consts/common/register-list';
import UnlimitedComponentContainer from '../components/customize-layout/draggable-components/container/unlimited-component-container';
import { componentDefinition } from '../components/customize-layout/component-definition';
import { GLOBAL_EVENT } from '../consts/common/global-event';
import { COMPARE, DIMENSION } from '../enum/common.enum';
import { ApartmentOutlined, DashboardOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import TralitSettings from '../components/common/tralit-settings';
import { useSelectorSize } from '../hooks/useWindowSize';

const Dashboard: React.FC = () => {
  const { color, menuCollapsed, selectedModule, authInfo, setMenuCollapsed, setAllComponents } = useContext(AppContext);
  const [showTralitSettings, setShowTralitSettings] = useState(false);
  const [userOperations, setUserOperations] = useState([]);

  const { selectorSize } = useSelectorSize({
    selector: '.react-grid-layout',
  });

  const components = useMemo(
    () => ({
      forecast: [
        {
          name: 'ForecastHeader',
          i: 'p01f01',
          x: 0,
          y: 0,
          w: 24,
          h: 1.5,
          padding: '',
          margin: '',
          type: 'ForecastHeader',
          triggerEventType: 'FILTER_ITEM_CHANGED',
          tag: 'filter',
          // condition: {
          //   /* table高亮kpi */
          //   selectedKpis: 'profit',
          //   /* 查询参数 Common*/
          //   /** 财务年度 */
          //   fiscalYear: 'FY25',
          //   /** 評価期間 enum EVALUATION_PERIOD*/
          //   evaluationPeriod: '今月単月',
          //   /** 比较对象 enum COMPARE */
          //   compare: 'plan',
          //   /** 比/差 enum SWITCH_VALUE */
          //   switchValue: true,
          //   /** 维度 enum DIMENSION*/
          //   dimension: 'daily',
          //   /* DrillDown 动态参数(非驼峰) 多个值「,」拼接 */
          //   drillFields: {
          //     biz_model: 'ORDER',
          //   },
          // },
        },
        {
          name: 'ForecastChartGroup',
          i: 'p01cg01',
          x: 0,
          y: 0,
          w: 24,
          h: 9.5,
          padding: '',
          margin: '',
          type: 'ForecastChartGroup',
          tag: 'container',
        },
        {
          name: 'ForecastTable',
          i: 'p01t01',
          x: 0,
          y: 0,
          w: 24,
          h: 13,
          padding: '',
          margin: '',
          type: 'ForecastTable',
          tag: 'table',
          canRedirect: true,
        },
      ],
      summary: [
        {
          name: 'CustomizeCompareChart',
          i: 'p0201c01',
          x: 0,
          y: 0,
          w: 24,
          h: 12,
          padding: '',
          margin: '',
          type: 'CustomizeCompareChart',
          tag: 'container',
          condition: {
            compare: 'plan',
          },
          eventType: GLOBAL_EVENT.PAGE_INIT,
          extra: false,
          action: '/tralit/compare',
          sort: 'name',
        },
        {
          name: 'CustomizeCompareChart',
          i: 'p0201c02',
          x: 0,
          y: 12,
          w: 24,
          h: 12,
          padding: '',
          margin: '',
          type: 'CustomizeCompareChart',
          tag: 'container',
          condition: {},
          eventType: GLOBAL_EVENT.PAGE_INIT,
          extra: false,
          action: '/tralit/compare',
          sort: 'name',
        },
      ],
      compare: [
        {
          name: 'CompareHeader',
          i: 'p0202f01',
          x: 0,
          y: 0,
          w: 24,
          h: 1.5,
          padding: '',
          margin: '',
          type: 'CompareHeader',
          triggerEventType: GLOBAL_EVENT.FILTER_ITEM_CHANGED,
          tag: 'filter',
          // condition: {
          //   /* table高亮kpi */
          //   selectedKpis: ['profit'],
          //   /* 查询参数 Common*/
          //   /** 财务年度 */
          //   fiscalYear: 'FY25',
          //   /** 評価期間 enum EVALUATION_PERIOD*/
          //   evaluationPeriod: '今月単月',
          //   /** 比较对象 enum COMPARE */
          //   compare: 'plan',
          //   /** 比/差 enum SWITCH_VALUE */
          //   switchValue: true,
          //   /** 维度 enum DIMENSION*/
          //   dimension: 'daily',
          //   /** 比较KPI */
          //   compareKpiKey: 'total_units',
          //   /** 比较Drill Down */
          //   compareDrillKeys: ['biz_model'],
          //   /* DrillDown 动态参数(非驼峰) 多个值「,」拼接 */
          //   drillFields: {
          //     biz_model: 'ORDER',
          //   },
          // },
        },
        // {
        //   name: 'CustomizeCompareChart',
        //   i: 'p0202c01',
        //   x: 0,
        //   y: 1.5,
        //   w: 12,
        //   h: 9.5,
        //   padding: '',
        //   margin: '',
        //   type: 'CustomizeCompareChart',
        //   tag: 'container',
        //   condition: {
        //     compare: 'plan',
        //   },
        //   extra: false,
        // },
        {
          name: 'CustomizeCompareChart',
          i: 'p0202c02',
          x: 0,
          y: 1.5,
          w: 24,
          h: 9.5,
          padding: '',
          margin: '',
          type: 'CustomizeCompareChart',
          tag: 'container',
          showPlan: true,
        },
        {
          name: 'CompareTable',
          i: 'p0202t01',
          x: 0,
          y: 11,
          w: 24,
          h: 13,
          padding: '',
          margin: '',
          type: 'CompareTable',
          tag: 'table',
        },
      ],
      risk: [
        {
          name: 'RiskHeader',
          i: 'p02f01',
          x: 0,
          y: 0,
          w: 24,
          h: 1.5,
          padding: '',
          margin: '',
          type: 'RiskHeader',
          triggerEventType: GLOBAL_EVENT.FILTER_ITEM_CHANGED,
          tag: 'filter',
          // condition: {
          //   /* table高亮kpi */
          //   selectedKpis: ['profit'],
          //   /* 查询参数 Common*/
          //   /** 财务年度 */
          //   fiscalYear: 'FY25',
          //   /** 評価期間 enum EVALUATION_PERIOD*/
          //   evaluationPeriod: '今月単月',
          //   /** 比较对象 enum COMPARE */
          //   compare: 'plan',
          //   /** 比/差 enum SWITCH_VALUE */
          //   switchValue: true,
          //   /** 维度 enum DIMENSION*/
          //   dimension: 'daily',
          //   /** 比较KPI */
          //   compareKpiKey: 'total_units',
          //   /** 比较Drill Down */
          //   compareDrillKeys: ['biz_model'],
          //   /* DrillDown 动态参数(非驼峰) 多个值「,」拼接 */
          //   drillFields: {
          //     biz_model: 'ORDER',
          //   },
          // },
        },
        {
          name: 'CustomizeRiskChart',
          i: 'p03c01',
          x: 0,
          y: 0,
          w: 24,
          h: 9.5,
          padding: '',
          margin: '',
          type: 'CustomizeRiskChart',
          tag: 'container',
        },
        {
          name: 'RiskTable',
          i: 'p03t01',
          x: 0,
          y: 0,
          w: 24,
          h: 13,
          padding: '',
          margin: '',
          type: 'RiskTable',
          tag: 'table',
        },
      ],
    }),
    []
  );

  const curMenuItem = useMemo(() => {
    return location.pathname.split('/').at(-1);
  }, [location.pathname]);

  const router = useMemo(
    () => ({
      key: 'tralit',
      logoUrl: '/sbt.png',
      title: 'AI Powered Management Cockpit',
      label: 'AI Powered Management Cockpit',
      path: '/tralit',
      icon: <span>sbt</span>, // todo need a design
      description: 'tralit description.',
      // descI18n: 'menu.sbt.description',
      footerText: `Accenture ©${new Date().getFullYear()}`,
      routes: [
        {
          key: '業績サマリー',
          path: '/tralit/forecast',
          label: '業績サマリー',
          // labeli18n: 'menu.mgmtDashboard',
          icon: <DashboardOutlined />,
          description: '業績サマリー',
        },
        {
          key: '業績差分分析',
          label: '業績差分分析',
          icon: <ApartmentOutlined />,
          description: '業績差分分析',
          children: [
            {
              key: '差分サマリー',
              path: '/tralit/summary',
              label: '差分サマリー',
              description: '差分サマリー',
            },
            {
              key: '差分詳細',
              path: '/tralit/compare',
              label: '差分詳細',
              description: '差分詳細',
            },
          ],
        },
        {
          key: '業績リスク分析',
          path: '/tralit/risk',
          label: '業績リスク分析',
          // labeli18n: 'menu.domainsDashboard',
          icon: <ApartmentOutlined />,
          description: '業績リスク分析',
        },
      ],
    }),
    []
  );

  useEffect(() => {
    if (componentDefinition) {
      setAllComponents({
        ...componentDefinition.StaticComponentDefinition,
        ...componentDefinition.CustomComponentDefinition,
      });
    }
  }, [componentDefinition]);

  useEffect(() => {
    const operations = [];
    if (process.env.REACT_APP_DISABLE_AUTH !== 'true') {
      operations.push({
        key: 'logout',
        label: (
          <span>
            <LogoutOutlined />
            <span style={{ padding: 8 }}>Logout</span>
          </span>
        ),
        onSelect: async () => {
          await authInfo.signOut();
        },
      });
    }
    setUserOperations(operations);
  }, []);

  return (
    <>
      <SiderMenuLayout
        header={
          <CoreHeader
            moduleInfo={selectedModule}
            userInfo={authInfo}
            color={color}
            otherOperations={[
              <>
                <div
                  style={{ float: 'right', paddingLeft: 25 }}
                  onClick={() => {
                    setShowTralitSettings(!showTralitSettings);
                  }}
                >
                  <SettingOutlined
                    style={{
                      fontSize: 24,
                      marginRight: 8,
                      top: 4,
                      position: 'relative',
                      color: color.theme === 'dark' ? '#ffffff' : color.primaryColor,
                    }}
                  />
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 'bolder',
                      top: 1,
                      position: 'relative',
                      paddingRight: 12,
                      color: color.theme === 'dark' ? '#ffffff' : color.primaryColor,
                    }}
                  >
                    設定
                  </span>
                </div>
              </>,
              <TralitSettings showSettings={showTralitSettings} setShowSettings={setShowTralitSettings} />,
            ]}
            userOperations={userOperations}
          />
        }
        content={
          <div className="generative-page-container">
            {components && curMenuItem ? (
              <UnlimitedComponentContainer
                width={selectorSize.width}
                components={components[curMenuItem]}
                autoLayout={false}
                rowHeight={(document.body.clientHeight - 105) / 24}
              />
            ) : (
              <></>
            )}
          </div>
        }
        contentLoading={false}
        color={color}
        collapsed={false}
        onCollapsed={setMenuCollapsed}
        moduleConfig={router}
        menu={<Menu selectedMenuKey={curMenuItem} menuItems={router.routes} color={color} menuCollapsed={menuCollapsed} />}
      />
    </>
  );
};
export default Dashboard;
